export default "__VITE_ASSET__DyQRrNos__"